import PrivateImage from '../presentation/PrivateImage';
import React, {useEffect, useRef, useState} from "react";
import {Redirect, useParams} from "react-router-dom";
import UserService from "../../services/user.service";
import '../../Print.css';
import { logOut} from "../../helpers/logout";
import {Button, Divider, Grid, Toolbar} from "@material-ui/core";
import ActionButton from "../form/input/ActionButton";
import Tooltip from "@material-ui/core/Tooltip";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import GeneratedDocumentEmailAction from "./GeneratedDocumentEmailAction";
import {PDFExport} from '@progress/kendo-react-pdf';
import {getPdfExportProxyProps, savePdfWithEmbeddedImages} from "../../helpers/pdfExport";
import {NotificationManager} from "react-notifications";


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    seeMore: {
        marginTop: theme.spacing(8),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    toolbarButtons: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1)
        }
    },
    marginElement: {
        margin: theme.spacing(2)
    },
    marginTop: {
        marginTop: theme.spacing(2)
    },
    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
        marginTop: theme.spacing(4),
    },
    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    cardMedia: {
        height: 200,
        width: 150,
        borderRadius: 10
    },
    cardContent: {
        flexGrow: 1,
    },
}));


const PricesGenerator = (props) => {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper);

    const pdfRef = useRef(null);
    const [funeral, setFuneral] = useState({
        contracting_authority: '',
        ca_email: '',
        ca_phone: '',
        ca_birth: '',
        ca_relationship: '',
        deceased: '',
        d_death: '',
        product_entities: [],
        service_entities: []
    });
    const [success, setSuccess] = useState(false);

    const [user, setUser] = useState(null);

    const funeral_id = useParams();
    const user_local = JSON.parse(localStorage.getItem('user')).id;

    useEffect(() => {
        UserService.getUser(user_local).then(
            (response) => {
                setUser(response.data);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
        UserService.getFuneral(funeral_id.funeral_id).then(
            (response) => {
                setFuneral(response.data);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
    }, [funeral_id.funeral_id, user_local, props]);

    const handleExport = () => {
        savePdfWithEmbeddedImages(pdfRef);
    }

    const countPrice = (entities) => {
        let sum = 0;
        funeral[entities].forEach((item) => {
            if (item.count_cost) {
                if (item.number) {
                    sum += item.number;
                }
                if(item.text_cost) {
                    sum += item.text_cost.cost;
                }
            }
        })
        return sum;
    }

    const showDelegation = () => {
        if (user) {
            const PageWatermark = () => (user.logo ? <div className="gendoc-page-watermark"><PrivateImage src={user.logo} alt=""/></div> : null);
            return <div className="document-preview-frame" style={{border: '1px solid'}}>
                <PDFExport ref={pdfRef} {...getPdfExportProxyProps()} paperSize="A4" scale={0.75}
                           fileName={`informacnylist-${funeral.deceased.replace(' ', '')}`}
                           pageTemplate={PageWatermark}>
                    <div className="a4-paper gendoc-doc gendoc-doc--flow">
                        <div className="gendoc-body">
                            <header className="gendoc-header">
                                <div className="gendoc-header__eyebrow">{user.name}</div>
                                <h1 className="gendoc-title">Informačné ceny k pohrebu</h1>
                                <div className="gendoc-header__meta">
                                    {user.address} · IČO: {user.ico} · IČ DPH: {user.ic_dph} · Kontakt: {user.phone} · Email: {user.email_official}
                                </div>
                            </header>

                            <section className="gendoc-section">
                                <h2 className="gendoc-section-title">Prehľad</h2>
                                <div className="gendoc-fields">
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Zosnulý/á</span>
                                        <span className="gendoc-value">{funeral.deceased}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Dátum úmrtia</span>
                                        <span className="gendoc-value">{funeral.d_death && new Date(funeral.d_death).toShortFormat()}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Obstarávateľ</span>
                                        <span className="gendoc-value">{funeral.contracting_authority} - {funeral.ca_relationship} - {funeral.ca_phone}</span>
                                    </div>
                                </div>
                            </section>

                            <section className="gendoc-section">
                                <h2 className="gendoc-section-title">Produkty</h2>
                                <table className="gendoc-table">
                                    <thead>
                                        <tr><th>Položka</th><th className="gendoc-num">Cena</th></tr>
                                    </thead>
                                    <tbody>
                                        {funeral.product_entities.map((item, i) => (
                                            <tr key={i}>
                                                <td>{item.name}{item.text_cost && item.text_cost.text ? <span className="gendoc-item-desc">{item.text_cost.text}</span> : null}</td>
                                                <td className="gendoc-num">{item.text_cost && item.text_cost.cost ? item.text_cost.cost + ' €' : ''}</td>
                                            </tr>
                                        ))}
                                        <tr className="gendoc-total"><td>Produkty, celková cena</td><td className="gendoc-num">{countPrice('product_entities')} €</td></tr>
                                    </tbody>
                                </table>
                            </section>

                            <section className="gendoc-section">
                                <h2 className="gendoc-section-title">Služby</h2>
                                <table className="gendoc-table">
                                    <thead>
                                        <tr><th>Položka</th><th className="gendoc-num">Cena</th></tr>
                                    </thead>
                                    <tbody>
                                        {funeral.service_entities.map((item, i) => (
                                            <tr key={i}>
                                                <td>{item.name}{item.text_cost && item.text_cost.text ? <span className="gendoc-item-desc">{item.text_cost.text}</span> : null}</td>
                                                <td className="gendoc-num">{item.text_cost && item.text_cost.cost ? item.text_cost.cost + ' €' : ''}</td>
                                            </tr>
                                        ))}
                                        <tr className="gendoc-total"><td>Služby, celková cena</td><td className="gendoc-num">{countPrice('service_entities')} €</td></tr>
                                    </tbody>
                                </table>
                            </section>
                        </div>
                    </div>
                </PDFExport>
            </div>
        }
        return <></>
    }

    return (
        <Container maxWidth="lg" className={classes.seeMore}>
            <div className={classes.root}>
                <Paper className={fixedHeightPaper}>
                    <Grid container>
                        <Grid xs={12} sm={4} md={3} lg={3} item container>
                            <Toolbar>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    hidden={true}
                                    className={classes.button}
                                    onClick={() => {
                                        setSuccess(true)
                                    }}
                                >
                                    Späť na detaily
                                </Button>
                            </Toolbar>
                        </Grid>
                        <Grid xs={12} sm={8} md={9} lg={9} item container justifyContent='flex-end'>
                            <Toolbar className={`${classes.toolbarButtons} document-actions-toolbar`}>
                                <ActionButton
                                    color="primary">
                                    <Tooltip title="Pdf export">
                                        <PictureAsPdfIcon
                                            fontSize="small"
                                            onClick={handleExport}
                                        />
                                    </Tooltip>
                                </ActionButton>
                                <GeneratedDocumentEmailAction
                                    pdfRef={pdfRef}
                                    funeral={funeral}
                                    user={user}
                                />
                            </Toolbar>
                        </Grid>
                    </Grid>

                    <Divider/>
                    <Grid className={classes.marginTop}
                          container
                          spacing={0}
                          direction="column"
                          alignItems="center"
                          justifyContent="center"
                    >
                        {showDelegation()}
                    </Grid>
                </Paper>
            </div>
            {success ? <Redirect to={{
                pathname: `/pohreb/${funeral_id.funeral_id}/info`,
                state: {from: props.location, number: 5}
            }}/> : <></>}
        </Container>
    )
}
export default PricesGenerator;

